module.exports = __webpack_public_path__ + "static/binary-3-7abed74a2973a5702f7baac2a2d2712a.png";